import { render, staticRenderFns } from "./OrdersListBig.vue?vue&type=template&id=3dfd08d9&"
import script from "./OrdersListBig.vue?vue&type=script&lang=js&"
export * from "./OrdersListBig.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListBig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrdersListBig.vue"
export default component.exports